export default {
  fa: {
    title: 'مدیریت زبان‌ها و ساب‌دامنه‌ها',
    loadError: 'خطا در بارگذاری تنظیمات زبان‌ها',
    saveSuccess: 'تنظیمات زبان‌ها با موفقیت ذخیره شد',
    saveError: 'خطا در ذخیره‌سازی تنظیمات',
    languageColumn: 'زبان',
    availabilityColumn: 'وضعیت در دسترس بودن',
    hostColumn: 'دامنه / ساب‌دامنه',
    dnsColumn: 'رکورد DNS مورد نیاز',
    lockedTooltip: 'زبان پیش‌فرض فارسی و انگلیسی غیرقابل غیرفعال‌سازی هستند.',
    enabledSwitch: 'فعال',
    disabledSwitch: 'غیرفعال',
    dnsAfterEnable: 'پس از فعال‌سازی نمایش داده می‌شود',
    cnameTooltip: 'شما می‌توانید ساب‌دامنه را به صورت CNAME به potterheads.org یا به صورت A Record به IP سرور اشاره دهید.',
    infoTitle: 'راهنمای ساب‌دامنه‌ها و دامنه‌های مجزا',
    infoBullet1: 'برای هر زبانی که <strong>فعال</strong> می‌کنید، باید رکورد DNS مربوطه را در پنل دامنه خود (کلودفلر یا غیره) اضافه کنید.',
    infoBullet2: 'فارسی روی دامنه <strong>potterhead.ir</strong> و انگلیسی روی دامنه اصلی <strong>potterheads.org</strong> قرار دارند.',
    infoBullet3: 'بقیه زبان‌ها بر روی ساب‌دامنه‌های دامنه اصلی (مانند <code>ja.potterheads.org</code>) فعال می‌شوند.',
  },
  en: {
    title: 'Languages & Subdomains Management',
    loadError: 'Failed to load language settings',
    saveSuccess: 'Language settings saved successfully',
    saveError: 'Failed to save settings',
    languageColumn: 'Language',
    availabilityColumn: 'Availability',
    hostColumn: 'Domain / Subdomain',
    dnsColumn: 'Required DNS Record',
    lockedTooltip: 'The default languages, Persian and English, cannot be disabled.',
    enabledSwitch: 'Enabled',
    disabledSwitch: 'Disabled',
    dnsAfterEnable: 'Shown after enabling',
    cnameTooltip: 'You can point the subdomain as a CNAME to potterheads.org or as an A Record to the server IP.',
    infoTitle: 'Guide to subdomains and separate domains',
    infoBullet1: 'For every language you <strong>enable</strong>, you must add the corresponding DNS record in your domain panel (Cloudflare or otherwise).',
    infoBullet2: 'Persian lives on <strong>potterhead.ir</strong> and English on the main domain <strong>potterheads.org</strong>.',
    infoBullet3: 'The remaining languages are enabled on subdomains of the main domain (e.g. <code>ja.potterheads.org</code>).',
  },
  de: {
    title: 'Verwaltung von Sprachen & Subdomains',
    loadError: 'Sprachlicheinstellungen konnten nicht geladen werden',
    saveSuccess: 'Spracheinstellungen erfolgreich gespeichert',
    saveError: 'Einstellungen konnten nicht gespeichert werden',
    languageColumn: 'Sprache',
    availabilityColumn: 'Verfügbarkeit',
    hostColumn: 'Domain / Subdomain',
    dnsColumn: 'Erforderlicher DNS-Eintrag',
    lockedTooltip: 'Die Standardsprachen Persisch und Englisch können nicht deaktiviert werden.',
    enabledSwitch: 'Aktiviert',
    disabledSwitch: 'Deaktiviert',
    dnsAfterEnable: 'Wird nach der Aktivierung angezeigt',
    cnameTooltip: 'Sie können die Subdomain als CNAME auf potterheads.org oder als A-Record auf die Server-IP verweisen lassen.',
    infoTitle: 'Anleitung zu Subdomains und separaten Domains',
    infoBullet1: 'Für jede Sprache, die Sie <strong>aktivieren</strong>, müssen Sie den entsprechenden DNS-Eintrag in Ihrem Domain-Panel (Cloudflare o.ä.) hinzufügen.',
    infoBullet2: 'Persisch liegt auf <strong>potterhead.ir</strong>, Englisch auf der Hauptdomain <strong>potterheads.org</strong>.',
    infoBullet3: 'Die übrigen Sprachen werden auf Subdomains der Hauptdomain aktiviert (z. B. <code>ja.potterheads.org</code>).',
  },
  es: {
    title: 'Gestión de idiomas y subdominios',
    loadError: 'Error al cargar la configuración de idiomas',
    saveSuccess: 'Configuración de idiomas guardada con éxito',
    saveError: 'Error al guardar la configuración',
    languageColumn: 'Idioma',
    availabilityColumn: 'Disponibilidad',
    hostColumn: 'Dominio / Subdominio',
    dnsColumn: 'Registro DNS requerido',
    lockedTooltip: 'Los idiomas predeterminados, persa e inglés, no se pueden deshabilitar.',
    enabledSwitch: 'Habilitado',
    disabledSwitch: 'Deshabilitado',
    dnsAfterEnable: 'Se muestra después de habilitar',
    cnameTooltip: 'Puede apuntar el subdominio como CNAME a potterheads.org o como registro A a la IP del servidor.',
    infoTitle: 'Guía de subdominios y dominios independientes',
    infoBullet1: 'Para cada idioma que <strong>habilite</strong>, debe agregar el registro DNS correspondiente en su panel de dominio (Cloudflare u otro).',
    infoBullet2: 'El persa está en <strong>potterhead.ir</strong> y el inglés en el dominio principal <strong>potterheads.org</strong>.',
    infoBullet3: 'El resto de idiomas se habilitan en subdominios del dominio principal (por ejemplo, <code>ja.potterheads.org</code>).',
  },
  fr: {
    title: 'Gestion des langues et sous-domaines',
    loadError: 'Échec du chargement des paramètres de langue',
    saveSuccess: 'Paramètres de langue enregistrés avec succès',
    saveError: "Échec de l'enregistrement des paramètres",
    languageColumn: 'Langue',
    availabilityColumn: 'Disponibilité',
    hostColumn: 'Domaine / Sous-domaine',
    dnsColumn: 'Enregistrement DNS requis',
    lockedTooltip: 'Les langues par défaut, le persan et l\'anglais, ne peuvent pas être désactivées.',
    enabledSwitch: 'Activé',
    disabledSwitch: 'Désactivé',
    dnsAfterEnable: "Affiché après activation",
    cnameTooltip: 'Vous pouvez pointer le sous-domaine en CNAME vers potterheads.org ou en enregistrement A vers l\'IP du serveur.',
    infoTitle: 'Guide des sous-domaines et domaines séparés',
    infoBullet1: 'Pour chaque langue que vous <strong>activez</strong>, vous devez ajouter l\'enregistrement DNS correspondant dans votre panneau de domaine (Cloudflare ou autre).',
    infoBullet2: 'Le persan se trouve sur <strong>potterhead.ir</strong> et l\'anglais sur le domaine principal <strong>potterheads.org</strong>.',
    infoBullet3: 'Les autres langues sont activées sur des sous-domaines du domaine principal (par ex. <code>ja.potterheads.org</code>).',
  },
  it: {
    title: 'Gestione lingue e sottodomini',
    loadError: 'Impossibile caricare le impostazioni della lingua',
    saveSuccess: 'Impostazioni della lingua salvate con successo',
    saveError: 'Impossibile salvare le impostazioni',
    languageColumn: 'Lingua',
    availabilityColumn: 'Disponibilità',
    hostColumn: 'Dominio / Sottodominio',
    dnsColumn: 'Record DNS richiesto',
    lockedTooltip: 'Le lingue predefinite, persiano e inglese, non possono essere disabilitate.',
    enabledSwitch: 'Abilitato',
    disabledSwitch: 'Disabilitato',
    dnsAfterEnable: "Mostrato dopo l'abilitazione",
    cnameTooltip: 'Puoi puntare il sottodominio come CNAME verso potterheads.org o come record A verso l\'IP del server.',
    infoTitle: 'Guida a sottodomini e domini separati',
    infoBullet1: 'Per ogni lingua che <strong>abiliti</strong>, devi aggiungere il relativo record DNS nel pannello del tuo dominio (Cloudflare o altro).',
    infoBullet2: 'Il persiano si trova su <strong>potterhead.ir</strong> e l\'inglese sul dominio principale <strong>potterheads.org</strong>.',
    infoBullet3: 'Le altre lingue vengono abilitate su sottodomini del dominio principale (es. <code>ja.potterheads.org</code>).',
  },
  ja: {
    title: '言語とサブドメインの管理',
    loadError: '言語設定の読み込みに失敗しました',
    saveSuccess: '言語設定が正常に保存されました',
    saveError: '設定の保存に失敗しました',
    languageColumn: '言語',
    availabilityColumn: '利用状況',
    hostColumn: 'ドメイン / サブドメイン',
    dnsColumn: '必要なDNSレコード',
    lockedTooltip: 'デフォルト言語であるペルシア語と英語は無効化できません。',
    enabledSwitch: '有効',
    disabledSwitch: '無効',
    dnsAfterEnable: '有効化後に表示されます',
    cnameTooltip: 'サブドメインをCNAMEでpotterheads.orgに、またはAレコードでサーバーIPに向けることができます。',
    infoTitle: 'サブドメインと独立ドメインのガイド',
    infoBullet1: '<strong>有効</strong>にする各言語について、ドメインパネル(Cloudflareなど)に対応するDNSレコードを追加する必要があります。',
    infoBullet2: 'ペルシア語は<strong>potterhead.ir</strong>、英語はメインドメインの<strong>potterheads.org</strong>にあります。',
    infoBullet3: 'その他の言語はメインドメインのサブドメイン(例: <code>ja.potterheads.org</code>)で有効になります。',
  },
  ko: {
    title: '언어 및 서브도메인 관리',
    loadError: '언어 설정을 불러오지 못했습니다',
    saveSuccess: '언어 설정이 성공적으로 저장되었습니다',
    saveError: '설정 저장에 실패했습니다',
    languageColumn: '언어',
    availabilityColumn: '사용 가능 여부',
    hostColumn: '도메인 / 서브도메인',
    dnsColumn: '필요한 DNS 레코드',
    lockedTooltip: '기본 언어인 페르시아어와 영어는 비활성화할 수 없습니다.',
    enabledSwitch: '활성화',
    disabledSwitch: '비활성화',
    dnsAfterEnable: '활성화 후 표시됩니다',
    cnameTooltip: '서브도메인을 CNAME으로 potterheads.org에 연결하거나 A 레코드로 서버 IP에 연결할 수 있습니다.',
    infoTitle: '서브도메인 및 별도 도메인 안내',
    infoBullet1: '<strong>활성화</strong>하는 각 언어마다 도메인 패널(Cloudflare 등)에 해당 DNS 레코드를 추가해야 합니다.',
    infoBullet2: '페르시아어는 <strong>potterhead.ir</strong>에, 영어는 기본 도메인인 <strong>potterheads.org</strong>에 있습니다.',
    infoBullet3: '나머지 언어는 기본 도메인의 서브도메인(예: <code>ja.potterheads.org</code>)에서 활성화됩니다.',
  },
  pt: {
    title: 'Gestão de idiomas e subdomínios',
    loadError: 'Falha ao carregar as configurações de idioma',
    saveSuccess: 'Configurações de idioma salvas com sucesso',
    saveError: 'Falha ao salvar as configurações',
    languageColumn: 'Idioma',
    availabilityColumn: 'Disponibilidade',
    hostColumn: 'Domínio / Subdomínio',
    dnsColumn: 'Registro DNS necessário',
    lockedTooltip: 'Os idiomas padrão, persa e inglês, não podem ser desativados.',
    enabledSwitch: 'Ativado',
    disabledSwitch: 'Desativado',
    dnsAfterEnable: 'Exibido após a ativação',
    cnameTooltip: 'Você pode apontar o subdomínio como CNAME para potterheads.org ou como registro A para o IP do servidor.',
    infoTitle: 'Guia de subdomínios e domínios separados',
    infoBullet1: 'Para cada idioma que você <strong>ativar</strong>, deve adicionar o registro DNS correspondente no painel do seu domínio (Cloudflare ou outro).',
    infoBullet2: 'O persa está em <strong>potterhead.ir</strong> e o inglês no domínio principal <strong>potterheads.org</strong>.',
    infoBullet3: 'Os demais idiomas são ativados em subdomínios do domínio principal (ex.: <code>ja.potterheads.org</code>).',
  },
};
